<template>
    <v-row class="ma-n8">
        <template v-for="seeker in seekers">
            <v-col cols="12" :key="seeker._id" class="pa-8">
                <auth-seekers-item v-bind="{ seeker, selected }" v-on="{ toggle }" />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import { mapState } from "vuex";
import authSeekersItem from "./auth-seekers-item.vue";

export default {
    components: { authSeekersItem },
    props: {
        value: { type: Array, default: () => [] }, // selected
    },
    data: () => ({
        selected: [],
    }),
    computed: {
        ...mapState("interview/server", ["seekers"]),
    },
    methods: {
        sync() {
            this.selected = [...(this.value || [])];
        },
        emit() {
            this.$emit("input", this.selected);
        },

        toggle(seeker) {
            let index = this.selected.findIndex((item) => item == seeker);
            if (-1 < index) this.selected.splice(index, 1);
            else this.selected.push(seeker);
            this.emit();
        },
    },
};
</script>

<style>
</style>